import { ChipProps } from '@mui/material';

// Remessa nova: ainda pode ser publicada no Diário Oficial
export const SUBMISSION_STATUS_NEW = 1;

export const SUBMISSION_STATUS_COLOR: Record<number, ChipProps['color']> = {
    1: 'primary',
    2: 'secondary',
    3: 'warning',
    4: 'error',
    5: 'success',
};

export const SUBMISSION_TYPE_OPTIONS = [
    { value: 1, label: 'Rotina' },
    { value: 2, label: 'Urgência' },
];
